type KITE_INPUT_TEXT_TYPES =
    | `date`
    | `datetime-local`
    | `email`
    | `month`
    | `multiline`
    | `number`
    | `password`
    | `tel`
    | `text`
    | `time`
    | `week`;

enum FORM_KITE_ELEMENTS_ENUM {
    checkbox = `KiteCheckbox`,
    select = `KiteSelect`,
    webform_select_other = `KiteSelect`,
    email = `KiteTextInput`,
    textfield = `KiteTextInput`,
    tel = `KiteTextInput`,
    textarea = `KiteTextInput`,
}

interface IFormItems {
    label: string;
    name: string;
    id: string;
    type: string;
    required: boolean;
    formItemId: string;
    formItemName: string;
    kiteComponent: string;
    multiple?: boolean;
    multiline?: boolean;
    inputStage?: number | 1;
    inputOptions?: any[];
    optionsFilter?: any[];
    emptyValue?: string;
    checked?: false;
    defaultValue?: string | boolean | number;
}

export interface IHeadingData {
    formHeadingText?: string;
    formHeadingTag?: `h1` | `h2` | `h3` | `h4` | `h5`;
    formHeadingSubtitle?: string;
    align?: `left` | `center`;
    static: boolean;
}

interface IDynamicForm {
    id?: string;
    node: string;
    submissionUrl: string;
    dynamicFormID: string;
    disclaimer?: string;
    formHeadingData?: IHeadingData;
    successPageUrl?: string;
}

interface IDynamicFormInputErrors {
    [key: string]: string;
}

export {
    IDynamicFormInputErrors,
    IDynamicForm,
    IFormItems,
    FORM_KITE_ELEMENTS_ENUM,
    KITE_INPUT_TEXT_TYPES,
};
